import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { ArrowLeft, Users, MessageSquare, BarChart3, Settings } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo, DevCredit } from "@/components/landing/Logo";
import { UsersTab, MessagesTab, AnalyticsTab, SettingsTab } from "@/components/admin/AdminTabs";

const TABS = [["users", "Users", Users, UsersTab], ["messages", "Messages", MessageSquare, MessagesTab], ["analytics", "Analytics", BarChart3, AnalyticsTab], ["settings", "Settings", Settings, SettingsTab]];

export default function Admin() {
  const { user } = useAuth();
  const [tab, setTab] = useState("users");
  if (!user?.is_admin) return <Navigate to="/dashboard" replace />;
  const Active = TABS.find((t) => t[0] === tab)[3];
  return (
    <div className="min-h-screen bg-[#EEF2F8]" data-testid="admin-page">
      <header className="sticky top-0 z-20 bg-[#EEF2F8]/80 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 md:px-10">
          <Logo />
          <Link to="/dashboard" className="neu-btn flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold" data-testid="admin-back-btn"><ArrowLeft className="h-4 w-4" />Library</Link>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-6 py-10 md:px-10">
        <p className="text-xs font-bold uppercase tracking-widest text-[#A62B8A]">Admin</p>
        <h1 className="mt-1 font-display text-4xl font-extrabold tracking-tight sm:text-5xl">Control centre</h1>
        <div className="neu-inset mt-8 inline-flex flex-wrap gap-1 rounded-full p-1.5">
          {TABS.map(([k, l, I]) => (
            <button key={k} onClick={() => setTab(k)} data-testid={`admin-tab-${k}`} className={`flex items-center gap-2 rounded-full px-5 py-2 text-sm font-semibold transition-all ${tab === k ? "neu-btn-primary" : "text-[#334155]"}`}><I className="h-4 w-4" />{l}</button>
          ))}
        </div>
        <div className="mt-8"><Active /></div>
      </main>
      <DevCredit className="pb-8 pt-4" />
    </div>
  );
}
